import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import XIcon from '@mui/icons-material/X';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className=" bottom-0 w-full">
      <div className="bg-customorange px-4 py-3">
        <div className="sm:flex sm:justify-center align-middle items-center">
          <div className="flex justify-center  items-center space-x-2 mx-2 hover:scale-105 transition-transform duration-300">
            <VerifiedUserIcon className="text-white mx-1" />
            {/* <img className="" src="assets/icons/insurance.svg" alt="" width={60} height={80} /> */}
            <Link to="/Ourpolicy" className=" text-white hover:text-black rounded-md  text-lg font-medium">
              {t('Privacy Policy')}
            </Link>
          </div>

          {/* <Link className="mx-4 text-white hover:text-black rounded-md px-3 py-2 text-lg font-medium">
            سياسة الخصوصية{' '}
          </Link> */}
          <div className="flex justify-center  items-center space-x-2 mx-2 hover:scale-105 transition-transform duration-300">
            {/* <img className="" src="assets/icons/FAQ.svg" alt="" width={60} height={70} /> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="text-white"
              width="1.5em"
              height="2em"
              viewBox="0 0 28 28"
            >
              <path
                fill="currentColor"
                d="M18 15H6l-4 4V3a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1m5-6v14l-4-4H8a1 1 0 0 1-1-1v-1h14V8h1a1 1 0 0 1 1 1M8.19 4c-.87 0-1.57.2-2.11.59c-.52.41-.78.98-.77 1.77l.01.03h1.93c.01-.3.1-.53.28-.69a1 1 0 0 1 .66-.23c.31 0 .57.1.75.28c.18.19.26.45.26.75c0 .32-.07.59-.23.82c-.14.23-.35.43-.61.59c-.51.34-.86.64-1.05.91C7.11 9.08 7 9.5 7 10h2c0-.31.04-.56.13-.74s.26-.36.51-.52c.45-.24.82-.53 1.11-.93s.44-.81.44-1.31c0-.76-.27-1.37-.81-1.82C9.85 4.23 9.12 4 8.19 4M7 11v2h2v-2zm6 2h2v-2h-2zm0-9v6h2V4z"
              />
            </svg>

            <span className="  text-white hover:text-white rounded-md text-lg font-medium">
              {t('Frequently Asked Questions')}
            </span>
          </div>

          {/* <div className="flex justify-center  items-center space-x-2 mx-2 hover:scale-105 transition-transform duration-300">
            <VolunteerActivismIcon className="text-white mx-1" />
            <Link className=" text-white hover:text-black rounded-md text-lg font-medium">
              {t('Donate By Text Message')}{' '}
            </Link>
          </div> */}
          {/* <div className="flex justify-center  items-center space-x-2 mx-2 hover:scale-105 transition-transform duration-300">
            <XIcon className="text-white mx-1 " />
            <Link
              to="https://x.com/shj_charity"
              className="text-white hover:text-black rounded-md text-lg font-medium"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('Sharjah Charity Twitter Account')}
            </Link>
          </div> */}

          <div className="flex justify-center  items-center space-x-2 mx-2 hover:scale-105 transition-transform duration-300">
            <LocalPhoneIcon className="text-white mx-1 " />
            <span className="text-white hover:text-black rounded-md  text-lg font-medium">{t('Call Us')}: 80014</span>
          </div>
        </div>
      </div>

      <div className="bg-customgreen">
        <div className="relative flex justify-center w-full">
          <div className="flex flex-col  md:flex md:flex-row  py-2 px-2 justify-between items-center w-full xl:w-5/6">
            <div className="flex justify-center w-full  md:justify-between md:w-1/2 ">
              {/* <div className="flex flex-col  mx-2 max-[345px]:items-center px-2 sm:flex-row-reverse items-center py-3">
              <div className='flex w-24 h-24 justify-center '>
              <img className="h-full w-full" src="/assets/images/Footer-logo.png" alt="" />
                </div>
              <div className='flex justify-center  text-center align-middle'>
              <Link className="mx-2 text-white text-center hover:text-black rounded-md px-3 py-2 text:sm md:text-lg font-medium">
                {t('Developed by')}
              </Link>
                </div>
           
            
            </div> */}
              <div className="flex sxx:flex-row flex-col  sm:flex-row  my-auto align-middle  items-center ">
                <div className="flex justify-center text-center">
                  <span className=" text-white hover:text-black rounded-md  py-2 text:sm md:text-lg font-medium">
                    {t('Download our app now')}
                  </span>
                </div>

                <div className="flex md:flex-col  items-center  lg:flex-row justify-between">
                  <img className="w-24 p-1 md:p-3 rounded-lg" src="/assets/getapp.png" alt="apple" />
                  <img className="w-24 p-1 md:p-3 rounded-lg" src="/assets/images/downoad.jpg" alt="app" />
                </div>
              </div>
            </div>

            <div className=" flex justify-center align-middle items-center ">
              <span className=" text-white justify-center text-center p-2 flex hover:text-black  text:sm md:text-lg font-medium">
               
                  &copy; {new Date().getFullYear()} {t('Sharjah Charity International All rights reserved')}
                
              </span>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
